import {
  FontSizes,
  Icon,
  Label,
  PrimaryButton,
  Separator,
  Spinner,
  SpinnerSize,
  Text
} from '@fluentui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useBoolean } from '@fluentui/react-hooks';
import SpecialtyMultiSelectorComponent, {
  SelectedSpecialtyType
} from '../../MedicalSpecialties/SpecialtySelector/SpecialtyMultiSelectorComponent';
import { SpecialtyViewModel } from '../../../models/Entities/Specialties/SpecialtyModels';
import { PractitionerSpecialtyAssociation } from '../../../models/Entities/PractitionerAssociations/Specialties/PractitionerSpecialtyAssociation';

// functions
import * as ComponentFunction from './PractitionerSpecialtyAssociatedListFunctions';

// styles
import './PractitionerSpecialtyAssociatedList.css';

export const PractitionerSpecialtyAssociatedListComponent = (
  props: ComponentFunction.Props
) => {
  const [t] = useTranslation();
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  useEffect(() => {
    props.GetSpecialtiesByPractitionerId(props.PractitionerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.PractitionerId]);

  const onAssociateSpecialty = (specialty: SpecialtyViewModel) => {
    props.AssociatePractitionerSpecialty({
      practitionerId: props.PractitionerId,
      specialtyId: specialty.id
    });
  };

  const onDisassociateSpecialty = (specialty: SelectedSpecialtyType) => {
    props.DisassociatePractitionerSpecialtyById(
      props.PractitionerId,
      specialty.ReferenceId
    );
  };

  const LoadingBlock = (
    <div className="LoadingBlock">
      <Spinner size={SpinnerSize.large} label={t('practitionerSpecialtyAssociated.renderBlock.loadingBlock')} />
    </div>
  );

  const ControlsBlock = (
    <div className="ControlsBlock">
      <PrimaryButton
        iconProps={ComponentFunction.AddIcon}
        text={t('practitionerSpecialtyAssociated.renderBlock.selectSpecialty')}
        onClick={openPanel}
        className="actionButton"
      />
      <SpecialtyMultiSelectorComponent
        isOpen={isOpen}
        openPanel={openPanel}
        dismissPanel={dismissPanel}
        SelectedSpecialties={ComponentFunction.GetSelectedSpecialties(
          props.SpecialtiesAssociated
        )}
        ErrorInformed={
          (props.FailOnAssociate ? props.ErrorOnAssociate : undefined) ||
          (props.FailOnDisassociate ? props.ErrorOnDisassociate : undefined)
        }
        onSelect={onAssociateSpecialty}
        onUnselect={onDisassociateSpecialty}
      />
    </div>
  );

  const SpecialtyAssociatedBlock = (
    <div className="SpecialtyAssociatedBlock">
      <ul>
        {props.SpecialtiesAssociated?.map(
          (assoc: PractitionerSpecialtyAssociation) => (
            <li key={assoc.id}>
              <Icon
                iconName="Stethoscope"
                style={{ fontSize: FontSizes.size24 }}
              />
              <div>
                <Label style={{ fontSize: FontSizes.size16 }}>
                  {assoc.specialty?.name ?? `${t('practitionerSpecialtyAssociated.renderBlock.specialtyFallback')}${assoc.specialtyId}`}
                </Label>
                {assoc.specialty?.snomedCode && (
                  <Text>{assoc.specialty.snomedCode}</Text>
                )}
              </div>
            </li>
          )
        )}
      </ul>
    </div>
  );

  const NoContentBlock = (
    <div className="NoData">
      <Separator />
      <label>{t('practitionerSpecialtyAssociated.ServiceAssociatedBlock.noSpecialtiesAssociated')}</label>
    </div>
  );

  return (
    <>
      {ControlsBlock}
      {props.IsLoading
        ? LoadingBlock
        : props.LoadedSuccessfully &&
          props.SpecialtiesAssociated?.length > 0
        ? SpecialtyAssociatedBlock
        : NoContentBlock}
    </>
  );
};

export default connect(
  ComponentFunction.mapStateToProps,
  ComponentFunction.mapDispatchToProps
)(PractitionerSpecialtyAssociatedListComponent as any);
